import styled from "styled-components";

export const CommentStyled = styled.div`
	.comment {
		font-size: var(--fz-caption);

		padding: 0 1.5rem;
		display: flex;

		align-items: flex-start;
		column-gap: 0.3rem;

		.comment-user-info {
			display: flex;
			align-items: flex-start;
			margin-right: 0.3rem;

			img {
				width: 40px;
				height: 40px;
				border-radius: 50%;
			}
		}

		.comment-message {
			max-width: 25ch;
			word-wrap: break-word;
			overflow-wrap: break-word;
			word-break: break-all;

			.username {
				font-size: var(--fz-caption);
				font-weight: var(--fw-semibold);
				margin-right: 5px;

				cursor: pointer;

				display: inline-flex;
				align-items: center;

				img {
					width: 12px;
				}
			}
		}

		.comment-interact {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			margin-left: auto;
			width: auto;

			div {
				display: flex;
				align-items: center;
				justify-content: space-between;

				button {
					cursor: pointer;
					display: flex;
					align-items: center;
					margin: 0.5rem 1rem;

					img {
						width: 20px; /* Ajuste o tamanho do ícone conforme necessário */
						height: auto;
						transition: all 0.3s ease;

						&:hover {
							filter: drop-shadow(0 0 8px var(--color-gray-7)) invert(39%) sepia(71%)
								saturate(1534%) hue-rotate(349deg) brightness(96%) contrast(98%);
						}
					}
				}
			}
		}
	}
`;
